import type { Currency } from "~/models";

const currencies: Currency[] = [
    {
        id: "1",
        code: "USD",
        symbol: "$",
    },
    {
        id: "2",
        code: "EUR",
        symbol: "€",
    },
    {
        id: "3",
        code: "SEK",
        symbol: "kr",
    },
];

export default currencies;
